import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setComposerHeight } from "../../../app/layoutSlice";
import { useParams } from "react-router-dom";

const useMessageComposer = ({
  onSubmit,
  onCreateDialog,
  dialogStatus,
  waiting,
  followUps,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const composerRef = useRef();
  const [value, setValue] = useState();
  const { dialogId } = useParams();

  const handleSend = () => {
    // document?.activeElement?.blur();
    if (value.replace(" ", "") !== "") {
      onSubmit(value);
      setValue("");
    }
    return true;
  };

  const handleKeyDown = (event) => {
    if (waiting) return false;
    if (event.key === "Enter") {
      if (event.shiftKey || event.ctrlKey || event.metaKey) {
        return false;
      } else {
        handleSend();
        return true;
      }
    }
  };

  const handleChange = (newValue) => {
    setValue(newValue);
  };

  const handleResize = () => {
    const { height: composerHeight } =
      composerRef?.current?.getBoundingClientRect();
    dispatch(setComposerHeight({ composerHeight }));
  };

  useEffect(() => {
    handleResize();
    // eslint-disable-next-line
  }, [value]);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      dispatch(setComposerHeight({ composerHeight: 0 }));
    };
    // eslint-disable-next-line
  }, []);

  const handleCreateDialog = (option) => {
    onCreateDialog({ dialogId, followUp: option });
  };

  const followUpButtons = followUps?.map((item) => ({
    ...item,
    onClick: () => {
      handleCreateDialog(item.id);
    },
  }));

  return {
    composerRef,
    composerAttribs: {
      onKeyDown: handleKeyDown,
      onChange: handleChange,
      value,
    },
    followUpButtons,
    onCreateDialog: handleCreateDialog,
    createDialogButtonCaption: t("chat.solveNextProblem"),
    dialogStatus,
    onSend: handleSend,
  };
};

export default useMessageComposer;
